export default
`
The Kübler-Ross model, also known as the “five stages of grief”, was first devised by the Swiss American psychiatrist Elisabeth Kübler-Ross in 1969. The model describes a series of emotions an individual may experience whilst undergoing grief. These include denial, bargaining, anger, depression and acceptance (and not necessarily in this order).\r\n
 
Today we recognise that that the Kübler-Ross model may be applied to a range of situations, including an individual’s reaction to being diagnosed with a life changing condition such as epilepsy.\r\n
 
In this collection of pieces, Patricia explores the five stages of grief. As an interdisciplinary researcher, Patricia works scientific concepts into each piece whilst drawing from her own experience of undergoing a diagnosis of epilepsy.  All mathematical models included were constructed by fellow SMQB member Dr Leandro Junges (UoB). 
`


// WEBPACK FOOTER //
// ./src/content/the-road-to-acceptance.js